/*
* Regional component list detail form - left column (component details)
*/

import * as _ from 'lodash';
import * as React from 'react';
import { Button, Row } from 'react-bootstrap';

import { BootstrapColXl as Col } from '../../common/bootstrap/bootstrapcolxl';
import * as KendoWrappers from '../../common/kendoforms/componentwrappers';
import * as DetailFormCommon from './common';

export const RegionalComponentListDetailFormComponentDetailsLeft = ({
    appText,
    handleFormInputChange,
    handleFormInputChangeEvaluationTier,
    handleFormInputChangeEvaluationVariant,
    handleFormInputCustomEvaluation,
    handleFormInputChangeUsefulLife,
    handleFormInputCategoryFilter,
    handleCalculate,
    handleSubmitForm,
    handleSaveChanges,
    numFormChanges,
    handleAddEvaluation,
    formData,
    defaultInputProps,
    sectionTitle,
    ...rest }) => {
    if (!appText || !formData) { return (<div />); }

    let inputPropsFullWidth = _.merge({}, defaultInputProps, {
        onChange: (n, v) => { handleFormInputChange(n, v); },
        className: 'inventory-detail-input-full-width',
    });

    let inputPropsFullWidthEvaluationTier = _.merge({}, defaultInputProps, {
        onChange: (n, v) => { handleFormInputChangeEvaluationTier(n, v); },
        className: 'edit-inventory-combo-evaluation-change',
    });

    let inputPropsFullWidthEvaluationVariant = _.merge({}, defaultInputProps, {
        onChange: (n, v) => { handleFormInputChangeEvaluationVariant(n, v); },
        className: 'edit-inventory-combo-evaluation-variant-change',
    });

    let inputPropsFullWidthTextDebounced = _.merge({}, defaultInputProps, {
        handleChange: (n, v) => { handleFormInputChange(n, v); },
        className: 'inventory-detail-input-full-width',
    });

    const inputPropsTextAreaDebounced = _.merge({}, defaultInputProps, {
        handleChange: (n, v) => { handleFormInputChange(n, v); },
        className: 'inventory-detail-input-full-width',
        colLabelXs: 12,
        colInputXs: 12,
    });

    const inputPropsCheckbox = _.merge({}, defaultInputProps, {
        onChange: (n, v) => { handleFormInputChange(n, v); },
    });

    let inputProps = _.merge({}, defaultInputProps, {
        onChange: (n, v) => { handleFormInputChange(n, v); },
    });

    let inputPropsUsefulLife = _.merge({}, defaultInputProps, {
        onChange: (n, v) => { handleFormInputChangeUsefulLife(n, v); },
    });

    let inputPropsVirtualizedSelect = _.merge({}, defaultInputProps, {});

    const saveNewCustomEvaluationButton = (numFormChanges === 0) ? <Button bsSize="xs" bsStyle="info" onClick={e => { handleAddEvaluation(e); }}>
        <i className="fa fa-save" />
    </Button> : <div />;

    return (
        <DetailFormCommon.RegionalDetailFormSection title={sectionTitle}>
            <div>
                <div>
                    <Row xs={12} className="kendo-form-row">
                        <Col xs={6} className="kendo-form-input-col">
                            <KendoWrappers.KendoVirtualizedSelectInput
                                name="componentCategoryFilter"
                                clearable={true}
                                label={appText('component-categories')}
                                labelKey="label"
                                valueKey="value"
                                required={false}
                                value={formData.selectedComponentCategoryOption}
                                options={formData.componentCategoriesOptions}
                                optionRenderer={DetailFormCommon.NameOptionRenderer}
                                onChange={(o) => { handleFormInputCategoryFilter(o); }}
                                {...inputPropsVirtualizedSelect}
                            />
                        </Col>
                        <Col xs={6} className="kendo-form-input-col">
                            <KendoWrappers.KendoVirtualizedSelectInput
                                name="componentId"
                                clearable={false}
                                label={appText('component')}
                                labelKey="label"
                                valueKey="value"
                                required={true}
                                value={formData.selectedComponentOption}
                                options={formData.groupedComponentOptions}
                                optionRenderer={DetailFormCommon.NameOptionRenderer}
                                onChange={(o) => { handleFormInputChange({ target: { name: 'componentId', type: 'virtualized-select' } }, o); }}
                                {...inputPropsVirtualizedSelect}
                            />
                        </Col>
                    </Row>
                    <DetailFormCommon.InventoryDetailFormSectionSpacing />
                    <Row xs={12} className="kendo-form-row">
                        <Col xs={7}>
                            <KendoWrappers.KendoTextInputDebounced
                                name="componentCustomName"
                                label={appText('component-override-name')}
                                value={formData.componentCustomName}
                                disableWrapper={false}
                                {...inputPropsFullWidthTextDebounced}
                            />
                        </Col>
                        <Col xs={5} className="kendo-form-input-col">
                            <KendoWrappers.KendoTextInputDebounced
                                name="componentDecimal"
                                label={appText('component-decimal-number')}
                                value={formData.componentDecimal}
                                disableWrapper={false}
                                {...inputPropsFullWidthTextDebounced}
                            />
                        </Col>
                    </Row>
                </div>

                <DetailFormCommon.InventoryDetailFormSectionSpacing />
                <div>
                    <KendoWrappers.KendoComboInput
                        name="location"
                        label={appText('location')}
                        value={formData.location}
                        data={formData.locationOptions}
                        allowCustom={true}
                        {...inputPropsFullWidth}
                    />
                </div>

                <div>
                    <KendoWrappers.KendoTextInputDebounced
                        name="quantity"
                        label={appText('quantity')}
                        value={formData.quantity}
                        {...inputPropsFullWidthTextDebounced}
                    />
                </div>
                <div>
                    <Row xs={12} className="kendo-form-ul-rul-row">
                        <Col xs={5}>
                            <div>
                                <KendoWrappers.KendoComboInput
                                    name="usefulLife"
                                    label={appText('useful-life')}
                                    value={formData.usefulLife}
                                    data={formData.usefulLifeOptions}
                                    allowCustom={true}
                                    {...inputPropsUsefulLife}
                                />
                            </div>
                        </Col>
                        <Col xs={5}>
                            <div>
                                <KendoWrappers.KendoNumberInput
                                    name="remainingUsefulLife"
                                    label={appText('remaining-useful-life')}
                                    value={formData.remainingUsefulLife}
                                    min={0}
                                    step={1}
                                    max={999}
                                    format="###"
                                    {...inputProps}
                                />
                            </div>
                        </Col>
                        <Col xs={2}>
                            <div/>
                        </Col>
                    </Row>
                </div>
                <DetailFormCommon.InventoryDetailFormSectionSpacing />

                <div>
                    <KendoWrappers.KendoCurrencyInput
                        name="bestCost"
                        label={appText('best-cost')}
                        value={formData.bestCost}
                        {...inputProps}
                    />
                </div>

                <div>
                    <KendoWrappers.KendoCurrencyInput
                        name="worstCost"
                        label={appText('worst-cost')}
                        value={formData.worstCost}
                        {...inputProps}
                    >
                        <div className="edit-inventory-calculate-button-wrapper">
                            <Button bsSize="xs" bsStyle="info" onClick={e => { handleCalculate(e); }}>
                                <i className="fa fa-calculator" /> {appText('buttons.calculate')}
                            </Button>
                        </div>
                    </KendoWrappers.KendoCurrencyInput>
                </div>

                <div>
                    <KendoWrappers.KendoDisabledInputHidden
                        name="avgCost"
                        label={appText('avg-cost')}
                        value={formData.avgCost}
                        {...inputProps}
                    />
                </div>

                <DetailFormCommon.InventoryDetailFormSectionSpacing />

                <div>
                    <KendoWrappers.KendoComboInputChildren
                        name="evaluationTier"
                        label={appText('evaluation-quality-tier')}
                        placeholder={appText('evaluation-quality-tier-placeholder')}
                        value={formData.evaluationTier}
                        data={formData.evaluationTierOptions}
                        allowCustom={false}
                        {...inputPropsFullWidthEvaluationTier}
                    >
                        <div className="edit-inventory-add-explanation-button-wrapper">
                            {saveNewCustomEvaluationButton}
                        </div>
                    </KendoWrappers.KendoComboInputChildren>
                </div>

                <div>
                    <KendoWrappers.KendoComboInput
                        name="evaluationTextVariant"
                        label={appText('evaluation-text-variant')}
                        placeholder={appText('evaluation-text-variant-placeholder')}
                        value={formData.evaluation}
                        data={formData.evaluationTextVariantOptions}
                        allowCustom={true}
                        {...inputPropsFullWidthEvaluationVariant}
                    />
                </div>

                <div>
                    <KendoWrappers.KendoTextareaDebounced
                        name="evaluation"
                        label={appText('evaluation')}
                        rows={4}
                        cols={40}
                        value={formData.evaluation}
                        onChange={handleFormInputCustomEvaluation}
                        {...inputPropsTextAreaDebounced}
                    />
                </div>

                <div>
                    <KendoWrappers.KendoCheckbox
                        name="saveEvaluationTextForFutureUse"
                        label={appText('evaluation-save-text-for-future-use')}
                        labelHelpTooltip={appText('evaluation-save-text-for-future-use.tooltip')}
                        value={formData.saveEvaluationTextForFutureUse}
                        {...inputPropsCheckbox}
                    />
                </div>
            </div>
        </DetailFormCommon.RegionalDetailFormSection>
    );
};



// WEBPACK FOOTER //
// ./src/regional-component-lists/detail-form/component-details-left.tsx